/**
 * The Content-Security-Policy (shared/csp.ts) allows no eval, and zod probes for it with `new Function` when an object
 * schema is defined, which the browser reports as a violation even though zod catches it. main.tsx imports this first,
 * before anything defines a schema (shared/schemas.ts does at load).
 */
import { z } from 'zod';

z.config({ jitless: true });
